<template>
  <section class="flex flex-column flex-space-between p-2">
    <article class="flex flex-column flex-justify-center flex-align-start">
      <h1 class="mb-4">Blackdevs Software</h1>
      <vue-typed-js :strings="typingStrings" :cursorChar="'|'" :loopCount="0" :shuffle="false">
        <h4>
          Blackdevs® - <span class="typing"></span>
        </h4>
      </vue-typed-js>
      <p class="justify-content-60" style="margin: 0px;">
        {{ $t('home.intro') }}.
      </p>
    </article>

    <article class="flex flex-space-between main-article">
      <div class="article-main-text">
        <p>
          Software &<br>
          Cloud &<br>
          Computing
        </p>
      </div>
      <div>
        <img class="article-main-image" src="assets/images/bg-01.png" alt="Background">
      </div>
    </article>

    <article class="flex flex-column flex-justify-center flex-align-start">
      <p class="justify-content-60">
        {{ $t('home.additional') }}.
      </p>
    </article>
  </section>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState(['language']),
  },
  data() {
    return {
      typingStrings: [],
    }
  },
  beforeMount() {
    this.checkLanguage(this.language);
  },
  methods: {
    checkLanguage(language) {
      if (language === 'pt-br') {
        this.typingStrings = ['Consultoria', 'em', 'Software', 'e', 'Cloud', 'Computing'];
      } else if (language === 'en-us') {
        this.typingStrings = ['Consulting', 'in', 'Software', 'and', 'Cloud', 'Computing'];
      }
    }
  },
  beforeDestroy() {}
}
</script>

<style scoped>
section {
  min-height: calc(100vh - 80px);
  width: auto;
}

section > article {
  height: auto;
  padding: 10px;
}

.main-article {
  flex-direction: row;
  align-items: center;
}

.article-main-text {
  animation: slide-up 1s ease;
}

.article-main-text > p {
  font-size: 3rem;
  font-weight: bold;
  max-width: 200px;
}

.article-main-image {
  max-height: 500px;
  min-height: 400px;
  width: 100%;
}

@media only screen and (max-width: 991px) {
  .main-article {
    flex-direction: column;
    align-items: flex-start;
  }

  .article-main-image {
    max-height: 300px;
    min-height: 100px;
  }
}
</style>